import { useMutation } from '@tanstack/react-query';
import axios from 'axios';
import { customFetchV2 } from '../services/custom-fetch-v2';
import { DeviceDataExport } from './useDeviceDataExports';

interface CreateDeviceDataExportRequest {
  deviceId: string;
  startDate: string;
  endDate: string;
  timeZone: string;
}

interface DeviceDataExportErrorResponse {
  error: string;
  message: string;
}

const createDeviceDataExport = async (
  request: CreateDeviceDataExportRequest,
): Promise<DeviceDataExport> => {
  try {
    const response = await customFetchV2<DeviceDataExport>(
      `/api/v2/devices/${request.deviceId}/data-exports`,
      {
        method: 'POST',
        body: {
          startDate: request.startDate,
          endDate: request.endDate,
          timeZone: request.timeZone,
        },
      },
    );

    if (!response.ok) {
      throw new Error('Unable to create data export.');
    }

    return response.data;
  } catch (error) {
    if (
      axios.isAxiosError<DeviceDataExportErrorResponse>(error)
      && error.response?.data?.message
    ) {
      throw new Error(error.response.data.message);
    }

    throw error;
  }
};

const useCreateDeviceDataExportMutation = () => useMutation({
  mutationFn: createDeviceDataExport,
});

export { useCreateDeviceDataExportMutation };
